import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";

const styles = (theme) => ({
  toggleContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start"
  },
  toggleButtonSelected: {},
  toggleGroup: {
    display: "flex",
    borderRadius: 4,
    backgroundColor: theme.ModalBGColor,
    boxShadow: "none"
  },
  toggleButton: {
    '&$toggleButtonSelected': {
      backgroundColor: theme.HeaderSelectedText,
      color: theme.ModalBGColor,
      '&:hover':{
        backgroundColor: theme.HeaderSelectedText,
      },
    },
    color: theme.dispatchPanelLabelValueColor,
    border: `1px solid ${theme.HeaderSelectedText}`,
    '&:first-child':{
      marginLeft:1,
      borderTopLeftRadius:4,
      borderBottomLeftRadius:4,
    },
    '&:last-child':{
        borderTopRightRadius:4,
        borderBottomRightRadius:4,
    },
    '&:not(:first-child)':{
        marginLeft:-1,
        borderLeftColor:"transparent"
    },
    '&:hover':{
        backgroundColor: theme.btnHoverColor,
    },
  },
});

const CustomToggleButtonGroup = (props) => {
  const { classes, value, options, handleChange } = props;
  return (
    <Grid container spacing={16}>
      <Grid item xs={12} sm={6}>
        <div className={classes.toggleContainer}>
          <ToggleButtonGroup
            classes={{ root: classes.toggleGroup }}
            value={value}
            exclusive
            onChange={handleChange}
          >
            {options.map((option) => (
              <ToggleButton
                value={option.value}
                classes={{
                  root: classes.toggleButton,
                  selected: classes.toggleButtonSelected
                }}
              >
                {option.label}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        </div>
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(CustomToggleButtonGroup);
